var Nielsen = require('bsdk-domless');

module.exports = { Nielsen: Nielsen };